// extracted by mini-css-extract-plugin
module.exports = {"container":"PopdReceipts_container__k4FYW","label":"PopdReceipts_label__3wxfg","error":"PopdReceipts_error__2k3Zd"};